import FeatureToggle, { FEATURE_TOGGLES } from 'sharedComponents/FeatureToggle';
import Chip from '@mui/material/Chip';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import MultiSitePopup from './MultiSitePopup';

const STANDBY = 'Standby';
const ACTIVE = 'Active';

const MultiSite = ({ multiSiteState }) => {
  const prevState = useRef(multiSiteState);
  const intl = useIntl();

  const [showPopup, setShowPopup] = useState(false);
  const [isInitialState, setIsInitialState] = useState(true);

  const showMultiSite = useMemo(() => {
    return multiSiteState?.mode === 'Multi';
  }, [multiSiteState]);

  useEffect(() => {
    const prev = prevState.current;

    // If initial state is STANDBY
    if (prev?.state === undefined && multiSiteState?.state === STANDBY) {
      setShowPopup(true);
      setIsInitialState(true);
    }

    // If state changes while polling
    if (prev?.state !== undefined && prev?.state !== multiSiteState?.state) {
      setShowPopup(true);
      setIsInitialState(false);
    }

    prevState.current = multiSiteState;
  }, [multiSiteState]);

  const closePopup = () => {
    setShowPopup(false);
    setIsInitialState(false);
  };

  const multiSiteLabel =
    multiSiteState?.state === ACTIVE
      ? {
          intl: defineMessage({ id: 'App-multiSite-label-Active', defaultMessage: 'Active' }),
          color: 'success',
        }
      : {
          intl: defineMessage({ id: 'App-multiSite-label-Standby', defaultMessage: 'Standby' }),
          color: 'warning',
        };

  return (
    showMultiSite && (
      <FeatureToggle name={FEATURE_TOGGLES.MULTI_SITE}>
        <MultiSitePopup
          open={showPopup}
          onClose={closePopup}
          currentState={multiSiteState}
          statusChanged={!isInitialState}
        />
        {multiSiteState?.state && (
          <Chip
            label={intl.formatMessage(multiSiteLabel.intl)}
            color={multiSiteLabel.color}
            size="small"
            sx={{ ml: 0, mr: 1 }}
          />
        )}
      </FeatureToggle>
    )
  );
};

export default MultiSite;
